import { ApolloProvider } from "@apollo/client";
import { Layer } from "@carbon/react";
import {
  AuthModeProvider,
  DetailPanelContainer,
  InternationalizationProvider as ReportingInternationalizationProvider,
  ReportingAuthGuard,
} from "@flaminem/reporting-admin";
import { useParams } from "react-router-dom";
import "@flaminem/reporting-admin/dist/style.css";

import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { getReportingApolloClient } from "src/graphql/reporting/apolloClient";
import { useLocale, useT } from "src/internationalization";

export const DashboardDetailPanelDisplay = () => {
  const { dashboardId } = useParams<{ dashboardId: string }>();
  const { locale } = useLocale();
  const t = useT();

  if (!dashboardId) {
    return <div>Dashboard ID is required</div>;
  }

  return (
    <ApolloProvider client={getReportingApolloClient()}>
      <AuthModeProvider authMode="bearer">
        <ReportingAuthGuard>
          <ReportingInternationalizationProvider locale={locale}>
            <PageStack>
              <PageHeader className="mb-5">{t("page.reporting.title")}</PageHeader>
              <Layer level={1}>
                <DetailPanelContainer dashboardId={dashboardId} />
              </Layer>
            </PageStack>
          </ReportingInternationalizationProvider>
        </ReportingAuthGuard>
      </AuthModeProvider>
    </ApolloProvider>
  );
};
